<script>
import '@/scss/_typography.scss'
import '@/scss/_utilities.scss'

export default {
  props: {
    title: {
      type: String,
      required: true,
      default: 'Digite seu titulo aqui...'
    },
    subTitle: {
      type: String,
      required: false,
      default: 'Digite seu titulo aqui...'
    }
  }
}
</script>

<template>
  <div class="mb-3">
    <h3>{{ title }}</h3>
    <p>{{ subTitle }} </p>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Typography/TitlePage/TitlePage.vue